import { stringify } from 'qs';
import request from '@/utils/request';
import { loginCompany, loginOrg } from '@/utils/LoginContext';
import { async } from 'q';

// 批量查询门店分播位方案
export async function queryScheme(payload) {
  return request(`/iwms-wms/wms/storeallocatebin/query?companyUuid=${payload.companyUuid}&dcUuid=${payload.dcUuid}&storeUuid=${payload.storeUuid ? payload.storeUuid : ""}`, {
    method: 'GET',
  });
}
// 新建门店分播位方案
export async function saveScheme(payload) {
  return request(`/iwms-wms/wms/storeallocatebin`, {
    method: 'POST',
    body: payload,
  })
}
// 编辑门店分播位方案
export async function modifyScheme(payload) {
  return request(`/iwms-wms/wms/storeallocatebin/modify`, {
    method: 'POST',
    body: payload,
  })
}
// 删除门店分播位方案
export async function removeScheme(payload) {
  return request(`/iwms-wms/wms/storeallocatebin/${payload.uuid}/remove?version=${payload.version}`, {
    method: 'DELETE',
  })
}
// 根据主键查询门店分播位方案
export async function getScheme(payload) {
  return request(`/iwms-wms/wms/storeallocatebin/${payload.uuid}`, {
    method: 'GET',
  });
}
// 设置默认门店分播位方案
export async function isDef(payload) {
  return request(`/iwms-wms/wms/storeallocatebin/${payload.uuid}/def?version=${payload.version}`, {
    method: 'POST',
  })
}
// 批量查询门店分播位组
export async function queryAllocateOrder(payload) {
  return request(`/iwms-wms/wms/storeallocatebin/queryGroup?${stringify(payload)}`, {
    method: 'GET',
  });
}
// 根据主键查询门店分播位组
export async function getAllocateOrder(payload) {
  return request(`/iwms-wms/wms/storeallocatebin/${payload.uuid}/group`, {
    method: 'GET',
  });
}
// 新建门店分播位组
export async function saveAllocateOrder(payload) {
  return request(`/iwms-wms/wms/storeallocatebin/group`, {
    method: 'POST',
    body: payload,
  });
}
// 编辑门店分播位组
export async function modifyAllocateOrder(payload) {
  return request(`/iwms-wms/wms/storeallocatebin/modify/group`, {
    method: 'POST',
    body: payload,
  });
}
//批量修改门店分播方案容器管理
export async function batchConfigContainerMgt(payload) {
  return request(`/iwms-wms/wms/storeallocatebin/batchConfigContainerMgt/${payload.schemeUuid}`, {
    method: 'POST',
    body: payload.modifiTionList,
  });
}
// 删除门店分播位组
export async function removeAllocateOrder(payload) {
  return request(`/iwms-wms/wms/storeallocatebin/${payload.uuid}/group?version=${payload.version}`, {
    method: 'DELETE',
  });
}
// 新建门店分播位
export async function saveAllocateOrderItem(payload) {
  return request(`/iwms-wms/wms/storeallocatebin/${payload.schemeUuid}/storeItem`, {
    method: 'POST',
    body: payload,
  });
}
// 编辑门店分播位
export async function modifyAllocateOrderItem(payload) {
  return request(`/iwms-wms/wms/storeallocatebin/${payload.schemeUuid}/storeItem/modify`, {
    method: 'POST',
    body: payload,
  });
}
// 分页查询门店分播位
export async function queryAllocateOrderItem(payload) {
  return request(`/iwms-wms/wms/storeallocatebin/store/page`, {
    method: 'POST',
    body: payload,
  });
}
// 这个服务不用调
export async function adjust(payload) {
  return request(`/iwms-wms/wms/storeallocatebin/adjust?${stringify(payload)}`, {
    method: 'POST',
  });
}
// 删除门店分播位
export async function removeAllocateOrderItem(payload) {
  return request(`/iwms-wms/wms/storeallocatebin/${payload.uuid}/store`, {
    method: 'DELETE',
  });
}
// 查询不在当前方案中的已启用的门店
export async function getStoreUCN(payload) {
  return request(`/iwms-wms/wms/storeallocatebin/getStoreUCN?companyUuid=${loginCompany().uuid}&schemeUuid=${payload.schemeUuid}`)
}
// 批量导入门店
export async function batchImport(payload) {
  return request(`/iwms-wms/wms/storeallocatebin/batchImport?fileKey=${payload.fileKey}&schemeUuid=${payload.schemeUuid}`, {
    method: 'POST',
    body: payload,
  });
}

// 根据方案uuid查询门店分播位明细
export async function queryStoreBySchemeUuid(payload) {
  return request(`/iwms-wms/wms/storeallocatebin/${payload.uuid}/queryStoreBySchemeUuid`, {
    method: 'GET',
  });
}


export async function saveallocateBinManageMentScheme(payload) {
  return request(`/iwms-wms/wms/allocateBinManageMentScheme/save`, {
    method: 'POST',
    body: payload
  })
}

export async function pageallocateBinManageMentScheme(payload) {
  return request(`/iwms-wms/wms/allocateBinManageMentScheme/page`, {
    method: 'POST',
    body: payload
  })
}

export async function modifyallocateBinManageMentScheme(payload) {
  return request(`/iwms-wms/wms/allocateBinManageMentScheme/modify`, {
    method: 'POST',
    body: payload
  })
}

export async function getallocateBinManageMentScheme(payload) {
  return request(`/iwms-wms/wms/allocateBinManageMentScheme/get?uuid=${payload.uuid}`, {
    method: 'GET',
  })
}

export async function getByDcAndCode(payload) {
  return request(`/iwms-wms/wms/allocateBinManageMentScheme/getByDcAndCode?code=${payload.code}&dcUuid=${payload.dcUuid}`, {
    method: 'GET',
  })
}


export async function deleteAllocateBinManageMentScheme(payload) {
  return request(`/iwms-wms/wms/allocateBinManageMentScheme/delete/${payload.uuid}`, {
    method: 'GET',
  })
}

export async function batchImportItems(payload) {
  return request(`/iwms-wms/wms/allocateBinManageMentScheme/batchImport?fileKey=${payload.fileKey}&schemeUuid=${payload.schemeUuid}`, {
    method: 'POST'
  })
}

export async function getAllocateBinManagementSchemeByCompanyAndDc(payload){
  return request(`/iwms-wms/wms/allocateBinManageMentScheme/getByDc?companyUuid=${payload.companyUuid}&dcUuid=${payload.dcUuid}`, {
    method: 'GET'
  })
}
